<script lang="ts">
	import { Alert, Button, Text } from '@Shelly/shelly-design-system';
	import { real_id } from 'src/helpers/interface_helpers';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import { format } from 'svelte-i18n';

	export let device: any;

	const id = real_id(device.id);

	let ts; //timestamp is used to show if the scan is already preformed or not
	let loadingScan = false;
	let loadingCheck = false;
	let availableStatus = $format('status_unknown', { default: 'Unknown' }); //availableStatus is used to visualize quick scan state if the scan is already preformed or not

	$: statusStore = getDeviceStatus(id);
	$: status = $statusStore;

	$: gearStatus =
		typeof status?.dali?.scan?.started_at !== 'undefined'
			? $format('status_in_progress', { default: 'In progress' })
			: typeof ts !== 'undefined' && typeof status?.dali?.scan?.started_at === 'undefined'
				? $format('status_done', { default: 'Done' })
				: $format('status_not_started', { default: 'Not started' }); //gearStatus is used to visualize scan state if the scan is already preformed or not

	$: controlGears = status?.dali?.cg_count || 0; //controlGears is used to visualize how many control gears/devices are found

	$: if (status?.dali?.scan?.started_at) {
		ts = status?.dali?.scan?.started_at;
	}

	$: if (Array.isArray(status?.dali?.errors) && status?.dali?.errors.length > 0 && gearStatus) {
		availableStatus = $format('status_failed', { default: 'Failed' });
	}

	const scanForControlGears = async () => {
		loadingScan = true;
		const params = {
			id: device.channel,
			config: {},
		};
		const method = 'dali.startScan';
		const res: SettingRequest = await gen2Request(device, method, params);
		loadingScan = false;
	};
	const pingKnownDevices = async () => {
		loadingCheck = true;
		availableStatus = $format('status_in_progress', { default: 'In progress' });
		const params = {
			id: device.channel,
			config: {},
		};
		const method = 'dali.pingKnownDevices';
		const res: SettingRequest = await gen2Request(device, method, params);
		if (typeof res?.errors?.code !== 'undefined') {
			availableStatus = $format('status_failed', { default: 'Failed' });
		} else {
			availableStatus = $format('status_done', { default: 'Done' });
		}
		loadingCheck = false;
	};
</script>

<Text styleType="body" class="mb-s">
	{$format('setup_dali_devices', {
		default: 'Setup DALI Devices',
	})}
</Text>
<Alert
	class="mb-s"
	heading={$format(`alert_state_status`, {
		default: `status: ${gearStatus}`,
		values: { status: gearStatus },
	})}
/>
<Alert
	class="mb-s"
	heading={$format(`found_control_gears`, {
		default: `found control gears: ${controlGears}`,
		values: { controlGears },
	})}
/>
<Button loading={loadingScan} class="mb-s" size="m" width="full" on:click={scanForControlGears}
	>{$format('button_scan_for_control_gear_devices', {
		default: 'Scan for Control Gear Devices',
	})}</Button
>

<Text styleType="body" class="mb-s">
	{$format('check_know_devices', {
		default: 'Check Known Devices',
	})}
</Text>
<Text styleType="body-extra-small" class="mb-s">
	{$format('quickly_check_known_devices', {
		default: 'Quickly check known devices',
	})}
</Text>
<Alert
	class="mb-s"
	heading={$format(`alert_state_status`, {
		default: `status: ${availableStatus}`,
		values: { status: availableStatus },
	})}
/>

<Button
	loading={loadingCheck}
	disabled={!controlGears}
	width="full"
	size="m"
	class="mb-s"
	on:click={pingKnownDevices}
	>{$format('button_check_devices', {
		default: 'Check Devices',
	})}</Button
>
